import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";

export const NS = "u2001";

const U2001: React.FC = () => {
  const { i18n } = useTranslation();
  const [i18nReady, setI18nReady] = useState<boolean>(false);

  useEffect(() => {
    i18n.loadNamespaces(["u2001"], (err) => {
      if (err) return console.error("Error loading namespace:", err);
      setI18nReady(true);
    });
  }, [i18n]);

  if (!i18nReady) return null;

  return <Outlet />;
};

export default U2001;
